import { useState } from 'react'
import Navigation      from './components/Navigation'
import Hero            from './components/Hero'
import Problem         from './components/Problem'
import Services        from './components/Services'
import WhoWeWorkWith   from './components/WhoWeWorkWith'
import WhyNorthCortex  from './components/WhyNorthCortex'
import About           from './components/About'
import Contact         from './components/Contact'
import Footer          from './components/Footer'
import BookingModal    from './components/BookingModal'

export default function App() {
  const [modalOpen, setModalOpen] = useState(false)

  const openModal  = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  return (
    <>
      <Navigation onBookCall={openModal} />

      <main>
        <Hero           onBookCall={openModal} />
        <Problem />
        <Services       onBookCall={openModal} />
        <WhoWeWorkWith />
        <WhyNorthCortex />
        <About />
        <Contact        onBookCall={openModal} />
      </main>

      <Footer />

      <BookingModal open={modalOpen} onClose={closeModal} />
    </>
  )
}
